import React from 'react';
import i18n from 'i18n-react';
import PropTypes from 'prop-types';
import Button from '../button/Button';
import SearchBoxContainer from '../../components/searchBoxContainer/SearchBoxContainer';
import * as LoggedUserCallcenterUC from '../../usecases/loggedUserCallcenter/LoggedUserCallcenterUC';
import Cookie from '../../const/Cookie';
import { withCookies, Cookies } from 'react-cookie';
import './MenuBar.css';

const propTypes = {
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  hideChangeSearch: PropTypes.bool,
  location: PropTypes.object,
};
class MenuBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      typeTrip: 'roundTrip',
      flightOrigin: null,
      flightDestiny: null,
      startDate: null,
      endDate: null,
      totalAdults: Number(1),
      totalKids: Number(0),
      totalBabys: Number(0),
      cabinCategory: 'ECONOMY',
      typeOfFlight: null,
      companiesIdentity: '',
      selectedTab: 'login'
    };

    this.loadFilter = this.loadFilter.bind(this);
  }

  componentWillMount() {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.flightsFilter
    ) {
      const filter = this.props.location.state.flightsFilter;
      this.loadFilter(filter);
      LoggedUserCallcenterUC.execute(this.props.location.state.keepLoggedUser);
    } else {
      LoggedUserCallcenterUC.execute();
    }

    this.logout(Cookie.USER_DATA_CALLCENTER);

    if (this.props.history) {
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: this.props.location.search,
        state: {}
      });
    }
  }

  loadFilter(filter) {
    this.setState({
      typeTrip: filter.typeTrip,
      flightOrigin: filter.flightOrigin,
      flightDestiny: filter.flightDestiny,
      startDate: filter.startDate,
      endDate: filter.endDate,
      totalAdults: filter.totalAdults,
      totalKids: filter.totalKids,
      totalBabys: filter.totalBabys,
      cabinCategory: filter.cabinCategory,
      typeOfFlight: filter.typeOfFlight,
      companiesIdentity: filter.companiesIdentity
    });
  }

  logout = loginDataCookie => {
    this.props.cookies.remove(loginDataCookie);
  };

  setSelectedTab(tab) {    
    this.setState({
      selectedTab: tab
    })   
    this.props.callbackTab(tab)
  }

  callbackCallcenterMode = isCallcenterMode => {    
    this.setState({
      isCallcenterMode: isCallcenterMode
    });
  }; 

  render() {
    return (
      <section className="main-menu" id="sectionMenuHorizontal">
        <div className="section__outer">
          <nav className="menu-0002">
            <ul className="menu-0002__list" id="main-menu" data-tab="">
              <li className={`${this.state.selectedTab === 'login' && 'sel'} menu-0002__item`}>
                <a>
                  <button
                    className="menu-0002__link skin-0012 page sel"
                    data-tab-item=""
                    style={{ cursor: 'pointer' }}
                    id="consultar-pnr"
                    onClick={() => this.setSelectedTab('login')}>
                    {i18n.translate('home.header.searchPNR')}
                  </button>
                  <div className="menu-0002__markup skin-0034" />
                </a>
              </li>

              <li className={`${this.state.selectedTab === 'search' && 'sel'} menu-0002__item`}>
                <a>
                  <button
                    className="menu-0002__link skin-0012 page sel"
                    data-tab-item=""
                    style={{ cursor: 'pointer' }}
                    id="menu-comprar-passagens"
                    onClick={() => this.setSelectedTab('search')}>
                    {i18n.translate('home.header.quoteTickets')}
                  </button>
                  <div className="menu-0002__markup skin-0034" />
                </a>
              </li>
              {this.state.selectedTab === 'search' ? (
                <div className="MenuBarSearchBoxContainer">
                  <SearchBoxContainer
                    {...this.state}
                    location={this.props.location}
                    loadRecentFlight={this.loadFilter}
                    callbackCallcenterMode={this.callbackCallcenterMode}
                  /></div>
              ) : null}

              {this.props.hideChangeSearch ? (
                ''
              ) : (
                <li>
                  <a id="changeSearch" data-test="changeSearchLink" href="/search">
                    <Button
                      name="changeSearch"
                      className="text-sm pull-right MenuBar__changeSearch"
                      disabled={false}
                      outline="white">
                      {i18n.translate('features.menuBar.changeSearch')}
                    </Button>
                  </a>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </section>
    )
  }
}

MenuBar.propTypes = propTypes;

export default withCookies(MenuBar);



// WEBPACK FOOTER //
// ./src/components/menuBar/MenuBar.jsx